import { render, staticRenderFns } from "./Schoolstaff.vue?vue&type=template&id=4e4c8f72"
import script from "./Schoolstaff.vue?vue&type=script&lang=js"
export * from "./Schoolstaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports